export default __webpack_public_path__ + "288f37190391af6db0bdf77671f7f902.svg";